import React, { FunctionComponent } from 'react';
import { Totaliser } from '@justgiving/totaliser';
import { useTranslation } from 'react-i18next';
import parseCurrency from '../../utils/parseCurrency';
import raisedPercentage from '../../utils/raisedPercentage';
import classNames from 'classnames';
import styles from './FundraiserTotals.scss';
import '@justgiving/totaliser/src/Totaliser.scss';

export type FundraiserTotalsProps = {
  targetAmount: number;
  raisedAmount: number;
  currencyCode: string;
  supporterCount: number;
};

export const FundraiserTotals: FunctionComponent<FundraiserTotalsProps> = ({
  targetAmount,
  raisedAmount,
  currencyCode,
  supporterCount,
}) => {
  const { t } = useTranslation('common', { useSuspense: false });

  if (raisedAmount === 0) {
    return null;
  }

  const percentage = raisedPercentage(targetAmount, raisedAmount);
  return (
    <div className={styles.wrapper}>
      {targetAmount > 0 && (
        <Totaliser
          size="small"
          percent={percentage}
          className={classNames(
            'jg-display-ib jg-space-mrsm',
            styles.totaliser,
          )}
        />
      )}
      <div>
        <span
          className={classNames(
            'jg-h5',
            'jg-text--brand',
            'jg-text-color-branded',
          )}
        >
          {parseCurrency(currencyCode, raisedAmount / 100)}
        </span>{' '}
        {supporterCount > 0 ? (
          <span className={classNames('jg-h5', styles.raised_by)}>
            {t('common.raisedBy_noTags', { count: supporterCount })}
          </span>
        ) : (
          <span className="jg-h5">{t('common.raised')}</span>
        )}
      </div>
    </div>
  );
};
